module.exports = __webpack_public_path__ + "84ccf57b5ac780e50d1bc9bef06ace08.jpg";